import {Component, OnInit} from '@angular/core';
import {RewardsAdminService} from '../../../../services/rewards-admin/rewards-admin.service';

@Component({
  selector: 'app-superadmin-export-rewards',
  templateUrl: './superadmin-export-rewards.component.html',
  styleUrls: ['./superadmin-export-rewards.component.scss'],
})
export class SuperadminExportRewardsComponent implements OnInit {
  rewardsList: any[] = [];
  showNotFoundMsg = true;

  constructor(private rewardsAdminService: RewardsAdminService) {}

  ngOnInit(): void {
    this.getRewardsList();
  }

  async getRewardsList(): Promise<void> {
    try {
      this.rewardsList = await this.rewardsAdminService.getRewards('', 0, 1000);
      if (this.rewardsList.length > 0) {
        this.showNotFoundMsg = false;
      }
    } catch (error) {
      console.error('Error in get rewards list', error);
    }
  }

  exportToJSON(data: any[], filename: string): void {
    const json: string = JSON.stringify(data);
    const blob: Blob = new Blob([json], { type: 'application/json' });
    const a: HTMLAnchorElement = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename + '.json';
    a.click();
    URL.revokeObjectURL(a.href);
  }
}
